module.exports = __webpack_public_path__ + "img/photo-3.2f703e49.png";